<template>
  <v-row class="justify-center no-gutters">
    <!-- month back -->
    <v-col>
      <v-btn
        fab
        left
        small
        depressed
        color="primary"
        class="mr-4"
        @click="
          () => {
            this.$emit('prev')
          }
        "
      >
        <i class="fas fa-chevron-left" />
      </v-btn>
      <v-btn
        left
        color="warning"
        class="mr-4"
        @click="
          () => {
            this.$emit('goToToday')
          }
        "
      >
        <i class="fas fa-calendar-day white--text" />
        <span class="ml-2 white--text">
          {{ $t('shopBackendBookingComplete.today') }}
        </span>
      </v-btn>
    </v-col>

    <!-- current month   -->
    <v-col class="text-center">
      {{ currentMonth | formatDate('MMMM - YYYY') }}
    </v-col>

    <!-- next month -->
    <v-col class="text-right">
      <v-btn
        right
        fab
        small
        depressed
        color="primary"
        @click="
          () => {
            this.$emit('next')
          }
        "
      >
        <i class="fas fa-chevron-right" />
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
export default {
  name: 'CapacityCalendarHeader',
  props: {
    currentMonth: {
      type: moment,
      required: true,
    },
  },
}
</script>
